<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="CLP Site Pages"
      title="CLP Site Pages"
      :clpSitePageSettings="clpSitePageSettings"
      :memberData="memberData"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'fa fa-th-large',
            path: `/${this.clpSitePageSettings.siteName}/rewards`,
          }"
        />

        <sidebar-item
          :link="{
            name: 'Update Profile',
            icon: 'fa fa-address-card',
            path: `/${this.clpSitePageSettings.siteName}/profile`,
          }"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <div v-if="!isEmailVerified" class="row">
        <div class="col">
          <div class="notif-required" @click="resendEmailVerification">
            Email not verified. Tap to activate and earn points!
          </div>
        </div>
      </div>
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view
            :clpSitePageSettings="clpSitePageSettings"
            :memberData="memberData"
            :sitePageTheme="sitePageTheme"
          ></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
    <notification-modal
      :visible="showModal"
      :message="modalMessage"
      :showResend="true"
      :cooldownStart="resendCooldownStart"
      :cooldownDuration="cooldownDuration"
      @resend="resendEmailVerification"
      @close="showModal = false"
    />
    <StickyFooter />
  </div>
</template>
<script>
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import StickyFooter from './StickyFooter.vue';
import { FadeTransition } from 'vue2-transitions';
import secureStorage from '../controllers/secureStorage';
import HTTPRequest from '../controllers/httpRequest';
import NotificationModal from './NotificationModal.vue';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
    StickyFooter,
    NotificationModal
  },

  data() {
    return {
      sidebarBackground: 'vue', //vue|blue|orange|green|red|primary,
      clpSitePageSettings: null,
      memberData: null,
      sitePageTheme: null,
      isEmailVerified: true,
      showModal: false,
      modalMessage: '',
      resendCooldownStart: null,
      cooldownDuration: 3600,
      resendEmailVerificationEndpoint:
        '/api/v2/clp_member_accounts/resend-email-verification',
      successResendMessage: `A verification link has been sent to your registered email address. Please verify your email address to start earning points with CWHD Rewards Program.`,
    };
  },

  methods: {  
    isCooldownActive() {
      if (!this.resendCooldownStart) return false;

      const elapsed = Math.floor((Date.now() - this.resendCooldownStart) / 1000);
      return elapsed < this.cooldownDuration;
    },
    async resendEmailVerification() {
      if (this.isCooldownActive()) {
        // Don't resend; just show modal with countdown
        this.showModal = true;
        return;
      }

      const url = this.resendEmailVerificationEndpoint;
      const { account_id: accountId, id: sitePageId } = this.clpSitePageSettings;
      const {
        membership_program_id: membershipProgramId,
        membership_number: membershipNumber,
      } = this.memberData;

      const query = {
        membership_program_id: membershipProgramId,
        membership_number: membershipNumber,
        account_id: accountId,
        site_page_id: sitePageId,
      };

      const requestResult = await HTTPRequest.getRequest(url, query);
      const { status, error } = requestResult;

      if (status === 200) {
        this.resendCooldownStart = Date.now(); // Set cooldown start
        this.showModal = true;
        this.modalMessage =
          'A verification link has been sent to your registered email address. Please check your inbox.';
      } else {
        this.modalMessage = error || 'Something went wrong. Please try again later.';
        this.showModal = true;
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {  
        this.$sidebar.displaySidebar(false);
      }
    },

    createSitePageTheme: function () {
      this.sitePageTheme = {
        header: {
          backgroundColor: this.clpSitePageSettings.header_bar_color,
          fontFamily: this.clpSitePageSettings.title_font,
        },
        body: {
          backgroundColor: this.clpSitePageSettings.background_color,
          fontFamily: this.clpSitePageSettings.body_font,
        },
      };
    },
  },

  created() {
    this.clpSitePageSettings = secureStorage.getItem('clpSitePageSettings');
    this.memberData = secureStorage.getItem('clpMemberData');
    this.createSitePageTheme();
    const { is_email_verified: isEmailVerified } = this.memberData;
    this.isEmailVerified = isEmailVerified;
  },
};
</script>
<style scoped>
.notif-required {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff; /* transparent red */
  color: #f46426;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: bold;
  font-family: sans-serif;
  box-shadow: 0 2px 6px rgba(255, 0, 0, 0.2);
  z-index: 9999;
  cursor: pointer;
}

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
